import React, { useState } from 'react';
import Reveal from '../components/Reveal/Reveal';
import api from '../services/api';
import { EMAIL_INPUT_PATTERN, EMAIL_INPUT_TITLE, isValidEmailAddress } from '../utils/emailValidation';
import './Contact.css';

const initialFormData = {
  name: '',
  email: '',
  subject: '',
  message: '',
};

const Contact = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    if (!isValidEmailAddress(formData.email)) {
      setSubmitError('Veuillez saisir une adresse email valide contenant @.');
      return;
    }

    try {
      setSubmitting(true);
      await api.contactMessages.create({
        full_name: formData.name.trim(),
        email: formData.email.trim(),
        subject: formData.subject.trim(),
        message: formData.message.trim(),
      });
      setSubmitted(true);
      setFormData(initialFormData);
    } catch (error) {
      console.error('Failed to submit contact message:', error);
      setSubmitError(error?.response?.data?.error || 'Impossible d\'envoyer votre message pour le moment. Veuillez reessayer.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <Reveal as="div" className="hero-content" variant="up">
          <h1>Nous Contacter</h1>
          <p>Notre équipe est à votre écoute</p>
        </Reveal>
      </section>

      {/* Contact Content */}
      <Reveal as="section" className="contact-content" variant="up" delay={60}>
        <div className="container">
          <div className="section-card">
            <div className="contact-grid">
              {/* Contact Form */}
              <div className="contact-form-container">
                <h2>Envoyez-nous un message</h2>
                
                {submitted ? (
                  <div className="success-message">
                    <div className="success-icon">✓</div>
                    <h3>Message envoyé !</h3>
                    <p>Merci pour votre message. Nous vous répondrons dans les plus brefs délais.</p>
                    <button 
                      className="new-message-btn"
                      onClick={() => setSubmitted(false)}
                    >
                      Envoyer un autre message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="contact-form">
                    {submitError && <div className="contact-submit-error">{submitError}</div>}

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="name">Nom complet *</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          placeholder="Votre nom"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="email">Email *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="votre@email.com"
                          pattern={EMAIL_INPUT_PATTERN}
                          title={EMAIL_INPUT_TITLE}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="subject">Sujet *</label>
                      <select
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Sélectionnez un sujet</option>
                        <option value="Demande de logement">Demande de logement</option>
                        <option value="Question sur le paiement">Question sur le paiement</option>
                        <option value="Probleme technique">Probleme technique</option>
                        <option value="Partenariat">Partenariat</option>
                        <option value="Autre">Autre</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Message *</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        placeholder="Décrivez votre demande..."
                        rows="6"
                      ></textarea>
                    </div>

                    <button type="submit" className="submit-btn" disabled={submitting}>
                      {submitting ? 'Envoi en cours...' : 'Envoyer le message'}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
};

export default Contact;
